import React, { useCallback, useEffect, useRef, useState } from 'react';
import Cropper from 'react-easy-crop';
import './ImageEditorBox.css';

import getCroppedImg from './cropImage'; // helper function below

const ImageEditorBox = ({ src, onClose, onCropDone, profileInputRef, isImageLoading, investorType = "" }) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const containerRef = useRef(null);
  const [aspect, setAspect] = useState(1); // default aspect ratio

  useEffect(() => {
    const updateAspect = () => {
      if (containerRef.current) {
        const { offsetWidth, offsetHeight } = containerRef.current;
        if (offsetWidth && offsetHeight) {
          setAspect(offsetWidth / offsetHeight);
        }
      }
    };

    // Initial call
    updateAspect();

    // Recalculate on window resize
    window.addEventListener('resize', updateAspect);
    return () => window.removeEventListener('resize', updateAspect);
  }, []);


  const onCropComplete = useCallback((croppedArea, croppedPixels) => {
    setCroppedAreaPixels(croppedPixels);
  }, []);

  const handleCrop = async () => {
    try {
      const croppedImage = await getCroppedImg(src, croppedAreaPixels);
      onCropDone(croppedImage); // send cropped image blob to parent
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <div className="imageEditor-overlay" onClick={onClose} />
      <div className={`imageEditor ${!src ? 'border' : ''}`}>
        <div
          className={`imageEditor-container default`}
          ref={containerRef}
        >
          <Cropper
            key={aspect}
            image={src}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            showGrid={false}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            restrictPosition={true}
            objectFit={'cover'}
          />
        </div>

        <div className="imageEditor-slider">
          <input
            type="range"
            min={1}
            max={3}
            step={0.1}
            value={zoom}
            onChange={(e) => setZoom(e.target.value)}
            className="custom-range"
            style={{ '--fill': `${((zoom - 1) / (3 - 1)) * 100}%` }}
          />
        </div>

        <div className="imageEditor-replace">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M11.2667 15H4.05773C3.58654 15 3.35095 15 3.24185 14.9068C3.14719 14.826 3.09696 14.7047 3.10673 14.5806C3.11798 14.4376 3.28457 14.271 3.61776 13.9378L10.2312 7.3244C10.5392 7.01639 10.6932 6.86238 10.8708 6.80468C11.027 6.75392 11.1952 6.75392 11.3515 6.80468C11.529 6.86238 11.6831 7.01639 11.9911 7.3244L15 10.3333V11.2667M11.2667 15C12.5735 15 13.2269 15 13.726 14.7457C14.165 14.522 14.522 14.165 14.7457 13.726C15 13.2269 15 12.5735 15 11.2667M11.2667 15H4.73333C3.42654 15 2.77315 15 2.27402 14.7457C1.83498 14.522 1.47802 14.165 1.25432 13.726C1 13.2269 1 12.5735 1 11.2667V4.73333C1 3.42654 1 2.77315 1.25432 2.27402C1.47802 1.83498 1.83498 1.47802 2.27402 1.25432C2.77315 1 3.42654 1 4.73333 1H11.2667C12.5735 1 13.2269 1 13.726 1.25432C14.165 1.47802 14.522 1.83498 14.7457 2.27402C15 2.77315 15 3.42654 15 4.73333V11.2667M6.83333 5.27778C6.83333 6.13689 6.13689 6.83333 5.27778 6.83333C4.41867 6.83333 3.72222 6.13689 3.72222 5.27778C3.72222 4.41867 4.41867 3.72222 5.27778 3.72222C6.13689 3.72222 6.83333 4.41867 6.83333 5.27778Z" stroke="#202330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
          <div className="label" onClick={() => profileInputRef?.current?.click()}>
            Replace picture
          </div>
        </div>

        <div className="imageEditor-divider" />
        <div className="imageEditor-buttons">
          <button onClick={onClose} className="cancel-button">
            Cancel
          </button>

          <button
            className={`img-set-button button ${isImageLoading ? 'btn_loading' : ''
              }`}
            onClick={() => { handleCrop(); }}
          >
            {isImageLoading ? (
              <div className="registerLoader">
                <div className="ring-loader"></div>
              </div>
            ) : (
              'Set picture'
            )}
          </button>
        </div>
      </div>

    </>
  );
};

export default ImageEditorBox;
